import React, { useEffect, useState } from "react";
import { config } from "../utils/config";
import { doRequest } from "../utils/helper";
import Loader from "../components/Loader";
import Sidebar from "../components/Sidebar";
import BillingHistoryItem from "../components/BillingHistoryItem";

export default function BillingHistory() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalVariation, setTotalVariation] = useState(0);

  const getHistory = async () => {
    setLoading(true);
    let userId = localStorage.getItem(config.USER_LOGIN_DETAILS)
      ? JSON.parse(localStorage.getItem(config.USER_LOGIN_DETAILS))?.id
      : null;
    if (!userId) return;
    let data = {
      user_id: userId,
    };

    try {
      let response = await doRequest(data, "POST", "order/history");
      if (+response?.resultFlag === 1) {
        let orderList = response?.response?.results;
        let total = 0;
        let variationCount = 0;

        console.log("order list is ", orderList); 

        for(const item of orderList){
          total += parseFloat(item?.price);
          variationCount += parseInt(item?.variant_count);  
        }

        // for (let i of a) {
        //   if(i.name === "Prepaid"){
        //     const itemPrice = i.price * i.total_variant;
        //     t += itemPrice + (i.tax / 100) * itemPrice; 
        //   }
        //   else{
        //     t += i.price + (i.tax / 100) * i.price;
        //   }

        //   variation += i.variant_count;
        // }



        setTotalAmount(total);
        setTotalVariation(variationCount);
        setList(orderList);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getHistory();
  }, []);
  return (
    <>
      {loading && <Loader />}
      <div
        id="main-container"
        className="container-fluid main"
        style={{ overflowY: "scroll" }}
      >
        <div class="left-main-menu">
        <Sidebar />
      </div>
      <section className="home" style={{paddingLeft: 0}}>
          <div className="container-fluid">
            <div className="billing-history">
              <div className="round-button">
                <i style={{ color: "#2A1FB3" }} className="fas fa-arrow-left" />
              </div>

              <div className="heading">
                <div style={{ paddingLeft: 0 }} className="text-center m-5">
                  <h1>Billing History</h1>
                </div>
              </div>
              <div className="row_bill_pad">
                <div className="row row_billing">
                  <div className="col-sm-3">
                    <h6 className="history_header">Total History</h6>
                  </div>
                  <div className="col-sm-2">
                    <h6 className="var_total">Total Amount</h6>
                    <h4 className="var_amount">
                      <sup>₹</sup>
                      <span>{totalAmount}</span>
                    </h4>
                  </div>
                  <div className="col-2 variation-header  ">
                    <h6 className="var_total">Variation Created</h6>
                    <h4 className="var_amount">
                      <span>{totalVariation}</span>
                    </h4>
                  </div>
                </div>

                <div className="">
                  <ul className="plan_billheader">
                    <li className="planbill_wid">
                      <h6>Plan</h6>
                    </li>

                    <li className="am_wid">
                      <h6>Amount</h6>
                    </li>

                    <li className="var_wid">
                      <h6>Variation Created</h6>
                    </li>

                    <li className="start_wid">
                      <h6>Start Date</h6>
                    </li>

                    <li className="end_wid">
                      <h6>End Date</h6>
                    </li>

                    <li className="stat_wid">
                      <h6>Status</h6>
                    </li>

                    <li className="dwnin_wid">
                      <h6 className="amt_right">Amount</h6>
                    </li>
                  </ul>

                  {list?.length > 0 ? (
                    <BillingHistoryItem list={list} getHistory={getHistory} />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
